/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Select from 'react-select';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { useCareLabelState } from '../context/index';
import { checkArray, customStyles } from '../../../../Components/helper';
import Loader from '../../../../Components/Utility/Loader/Loader';
import CodeText from './code';
import DiscriptionText from './discription';
import EditAction from './EditAction';
import ViewAction from './ViewAction';

function InstructionDisclaimerTable({ handleDelete, CareAddEditAccess, CareDeleteAccess }) {
  const { t } = useTranslation('common');

  const {
    careLabelState,
    handleCheckAll,
    handleCheckLibrary,
    isallChecked,
    disclaimerTypeOption,
    careTypeOption,
    handleClose,
    handleInputChange,
    handleSelectChange,
    handleAddUpdate,
    handleEdit,
    handlePageNextInScroll,
  } = useCareLabelState();
  const { CareLabelList, pageLoader, activeCareType, selectedLibrary, editedId, uploadingData, hasMore } = careLabelState;

  const setCareLabelType = (eleItem) => {
    return activeCareType === 'disclaimer' ? eleItem.disclaimerType : eleItem.careType;
  };
  const activeName = activeCareType === 'disclaimer' ? 'disclaimerType' : 'careType';
  const typeOption = activeCareType === 'disclaimer' ? disclaimerTypeOption : careTypeOption;

  return pageLoader ? (
    <Loader />
  ) : (
    <div
      id="scrollableDivInstDis"
      className="mt-2"
      style={{
        height: 'calc(100vh - 250px)',
        overflow: 'auto',
      }}
    >
      <InfiniteScroll
        dataLength={CareLabelList?.length}
        hasMore={hasMore}
        next={() => handlePageNextInScroll()}
        scrollableTarget="scrollableDivInstDis"
        className="fixed-col-container"
      >
        <table className="table custom-table layout-fixed fixed-table-th">
          <thead>
            <tr>
              <th className="w-80px w-xs-40px">
                <div className="checkbox-label no-label margin-auto">
                  <input
                    type="checkbox"
                    name={`check_all_${activeCareType}`}
                    id={`check_all_${activeCareType}`}
                    onChange={(e) => handleCheckAll(e)}
                    checked={isallChecked}
                  />
                  <label htmlFor={`check_all_${activeCareType}`} className="chklabel">
                    <span />
                  </label>
                </div>
              </th>
              <th className="w-200px">{t('CARE_LABELS.TABLE.INSTRUCTION_DISCLAIMER.CODE')}</th>
              <th className="w-300px">{t('CARE_LABELS.TABLE.INSTRUCTION_DISCLAIMER.DESCRIPTION')}</th>
              <th className="w-200px">{activeCareType === 'disclaimer' ? 'Disclaimer Type' : 'Care Type'}</th>
              <th className="w-150px">{t('CARE_LABELS.TABLE.INSTRUCTION_DISCLAIMER.ACTION')}</th>
            </tr>
          </thead>
          <tbody>
            {checkArray(CareLabelList) ? (
              CareLabelList.map((eleItem, i) => {
                const activeType = typeOption.find((ele) => ele.id === eleItem[`${activeName}`]);
                const isEditOpen = eleItem?.editMode && (eleItem._id === editedId || eleItem.newItem);

                return (
                  <tr key={eleItem?._id}>
                    <td>
                      <div className="checkbox-label no-label margin-auto">
                        <input
                          type="checkbox"
                          name={`${activeCareType}_${i}`}
                          id={`${activeCareType}_${i}`}
                          checked={selectedLibrary?.includes(eleItem?._id)}
                          onChange={(e) => handleCheckLibrary(e.target.checked, eleItem._id)}
                        />
                        <label htmlFor={`${activeCareType}_${i}`} className="chklabel">
                          <span />
                        </label>
                      </div>
                    </td>
                    <td>{isEditOpen ? <CodeText eleItem={eleItem} handleInputChange={handleInputChange} i={i} /> : eleItem.code}</td>
                    <td>{isEditOpen ? <DiscriptionText eleItem={eleItem} handleInputChange={handleInputChange} i={i} t={t} /> : eleItem.description}</td>
                    <td>
                      {isEditOpen ? (
                        <>
                          <Select
                            className="text-dark"
                            options={typeOption}
                            styles={customStyles}
                            placeholder={t('CARE_LABELS.TABLE.INSTRUCTION_DISCLAIMER.SELECT_TYPE')}
                            getOptionLabel={(option) => `${option.label}`}
                            getOptionValue={(option) => `${option.id}`}
                            menuPosition="fixed"
                            value={activeType}
                            onChange={(e) => handleSelectChange(e, eleItem, activeName, i)}
                          />
                          <span className="error-message">
                            {eleItem?.errors?.includes(activeName) && t('CARE_LABELS.TABLE.INSTRUCTION_DISCLAIMER.TYPE_SELECTION_REQUIRED')}
                          </span>
                        </>
                      ) : (
                        setCareLabelType(eleItem)
                      )}
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {isEditOpen ? (
                          <EditAction eleItem={eleItem} handleAddUpdate={handleAddUpdate} handleClose={handleClose} isUploading={uploadingData} />
                        ) : (
                          <ViewAction
                            eleItem={eleItem}
                            handleEdit={handleEdit}
                            CareAddEditAccess={CareAddEditAccess}
                            CareDeleteAccess={CareDeleteAccess}
                            handleDelete={handleDelete}
                            i={i}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={5}>
                  <p className="text-center m-0">
                    {t('CARE_LABELS.TABLE.INSTRUCTION_DISCLAIMER.NO_CARE_LABEL')} {`${activeCareType}`}{' '}
                    {t('CARE_LABELS.TABLE.INSTRUCTION_DISCLAIMER.LIBRARY_ENTRY_FOUND')}
                  </p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  );
}

export default InstructionDisclaimerTable;
